export const stepTypes = [
  {
    key: "TEACH_INTRO",
    value: "TEACH_INTRO",
    lessonKey: "intro_step",
  },
  {
    key: "TEACH_GRAMMAR_INTRO",
    value: "TEACH_GRAMMAR_INTRO",
  },

  // TEACHER_LESSON
  {
    section: "TEACHER_LESSON",
    key: "Vocabulary",
    value: "TEACH_VOCABULARY",
    lessonKey: "vocabulary_step",
  },
  {
    section: "TEACHER_LESSON",
    key: "Listening",
    value: "TEACH_LISTENING",
    lessonKey: "audio_text_step",
  },
  {
    section: "TEACHER_LESSON",
    key: " Pronunciation ",
    value: "TEACH_PRONUNCIATION",
    lessonKey: "audio_transcript_step",
  },
  {
    section: "TEACHER_LESSON",
    key: "Grammar",
    value: "TEACH_EXERCISE",
    lessonKey: "grammar_step",
  },
  {
    section: "TEACHER_LESSON",
    key: "Speaking",
    value: "TEACH_SPEAK",
    lessonKey: "speaking_step",
  },
  {
    section: "TEACHER_LESSON",
    key: "Homework",
    value: "TEACH_HOMEWORK",
    lessonKey: "conclusion_step",
    stepTitle: "Self-practice",
  },
  {
    section: "TEACHER_LESSON",
    key: "Custom HW",
    value: "TEACH_ASSIGNMENTS",
    lessonKey: "conclusion_step",
  },

  // PRACTICE
  {
    section: "PRACTICE",
    key: "Vocabulary",
    value: "PRACTICE_VOCABULARY",
    lessonKey: "vocabulary_step",
  },
  {
    section: "PRACTICE",
    key: "Listening",
    value: "PRACTICE_LISTENING",
    lessonKey: "audio_text_step",
  },
  {
    section: "PRACTICE",
    key: "Transcript ",
    value: "PRACTICE_TRANSCRIPT",
    lessonKey: "audio_transcript_step",
  },
  {
    section: "PRACTICE",
    key: "Pronunciation",
    value: "PRACTICE_PRONUNCIATION",
    lessonKey: "pronunciation_step",
  },
  {
    section: "PRACTICE",
    key: "Speaking",
    value: "PRACTICE_SPEAK",
    lessonKey: "speaking_step",
  },
  {
    section: "PRACTICE",
    key: "Homework",
    value: "PRACTICE_HOMEWORK",
    lessonKey: "conclusion_step",
    stepTitle: "Self-practice",
  },
  {
    section: "PRACTICE",
    key: "Custom HW",
    value: "PRACTICE_ASSIGNMENTS",
    lessonKey: "conclusion_step",
  },

  { key: "GRAMMAR_EXERCISE", value: "GRAMMAR_EXERCISE" },
];

export const PracticeStepDefinition = stepTypes
  .filter((step) => step.section === "PRACTICE")
  .map((step) => step.key);

export const LessonsStepDefinition = stepTypes
  .filter((step) => step.section === "TEACHER_LESSON")
  .map((step) => step.key);

export const PracticeSteps = stepTypes.filter((step) => step.section === "PRACTICE");

export const LessonsSteps = stepTypes.filter((step) => step.section === "TEACHER_LESSON");
